import { useFrame, useThree } from "@react-three/fiber";
import { useEffect } from "react";

/**
 * Manages the 3D scene background.
 *
 * The canvas is always rendered with a transparent background so the CSS
 * background on the viewport container div shows through.
 *
 * Uses useFrame to force-clear the framebuffer every frame, preventing
 * smearing artifacts from preserveDrawingBuffer.
 */
export function BackgroundImage() {
  const { scene, gl } = useThree();

  useEffect(() => {
    scene.background = null;
    gl.setClearColor(0x000000, 0);
  }, [scene, gl]);

  // Force-clear every frame to prevent smearing.
  // When preserveDrawingBuffer is true, the buffer persists between
  // presentations. Without an explicit clear, stale alpha values from
  // the previous frame can bleed through.
  useFrame(() => {
    gl.autoClear = false;
    gl.clearColor();
    gl.clearDepth();
    gl.autoClear = true;
  }, -100); // Priority -100: run before all other useFrame callbacks

  // Keep canvas transparent for CSS background compositing
  useEffect(() => {
    gl.domElement.style.background = "transparent";
  }, [gl]);

  return null;
}
